import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { Inventory } from '../Models/Inventory';
import { InventoryDailyPrice } from '../Models/InventoryDailyPrice';
import { InventoryLoadIn } from '../Models/InventoryLoadIn';

class InventoryApi {
  static getInventory(id: string) {
    return axios.get<Inventory>(
      `${API_URL}/api/inventory/${id}`,
      getAuthHeader()
    );
  }
  static getInventoryList() {
    return axios.get<Inventory[]>(`${API_URL}/api/inventory`, getAuthHeader());
  }
  static addUpdateInventory(request: Inventory) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/inventory`,
      request,
      getAuthHeader()
    );
  }
  static getInventoryDailyPrice(id: string) {
    return axios.get<InventoryDailyPrice>(
      `${API_URL}/api/inventory/dailyprice/${id}`,
      getAuthHeader()
    );
  }
  static getInventoryDailyPriceList() {
    return axios.get<InventoryDailyPrice[]>(
      `${API_URL}/api/inventory/dailyprice/list`,
      getAuthHeader()
    );
  }
  static addUpdateInventoryDailyPrice(request: InventoryDailyPrice) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/inventory/dailyprice`,
      request,
      getAuthHeader()
    );
  }
  static getInventoryLoadInList() {
    return axios.get<InventoryLoadIn[]>(
      `${API_URL}/api/inventory/loadin/list`,
      getAuthHeader()
    );
  }
  static addUpdateInventoryLoadIn(request: InventoryLoadIn) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/inventory/loadin`,
      request,
      getAuthHeader()
    );
  }
}

export default InventoryApi;
